import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/new/images/svg/logo.svg")